import { firestoreTimestampToDate, isDate } from "..";

export interface ILifeSign {
    structureVersion: string|undefined
    identifier: string|undefined
    appName: string|undefined
    contextId: string|undefined
    deviceName: string|undefined
    userId: string|undefined
    userName: string|undefined
    timeStamp: Date|undefined
    updateTimestamp: Date|undefined
}

export class LifeSign implements ILifeSign {

    className = "LifeSign"

    structureVersion: string | undefined;
    identifier: string | undefined;
    appName: string | undefined;
    contextId: string | undefined;
    deviceName: string | undefined;
    userId: string | undefined;
    userName: string |undefined;
    timeStamp: Date | undefined;
    updateTimestamp: Date | undefined;


    constructor(
        appName?: string,
        contextId?: string,
        deviceName?: string,
        userId?: string,
        userName?: string
    ) {
        this.appName = appName
        this.contextId = contextId
        this.deviceName = deviceName
        this.userId = userId
        this.userName = userName
        if (appName && deviceName && userId) {
            this.identifier = `${appName}-${deviceName}-${userId}`
        }
    }

    setFromAny(data: any) {
        // unsave 
        const {updateTimestamp, timeStamp} = data
        Object.assign(this, data)
        this.updateTimestamp = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
        this.timeStamp = timeStamp ? isDate(timeStamp) ? timeStamp : firestoreTimestampToDate(timeStamp) : this.timeStamp
    }

    getListItemTitle(): string {
        return `${this.deviceName ? this.deviceName : "Unknown"} - ${this.userName ? this.userName : "Unknown"}`
    }

    getListItemSubTitle(locale: string|undefined, options: any|undefined): string {
        let opts = options
        if (!opts) opts = {weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', seconds: 'numeric'} 
        return `${this.updateTimestamp ? this.updateTimestamp.toLocaleTimeString(locale, opts) : "Unknown"}`
    }

    searchFilter(filter: string): boolean {
        const str = `${this.deviceName}${this.userName}`.toLowerCase()
        return str.includes(filter)
    }

    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key 
     */
     replacerFn(key: string) {
        if (key == "className") return false
        else return true
    } 
}